import getQueryString from 'Common/getQueryString';
import { getDisplay, getAndFormat } from 'Common/formValues';
import * as R from 'ramda';
// This is for retaining the filter in url while creating the query from the filter form.
// It is used for nearly new deals - linked from whatcar reviews page
const extraParamsFromUrl = ['minOdometerReadingMiles', 'minPlate', 'maxPlate'];

export default (form, urlParams = '') => {
  const pathname = window.location.pathname;
  var path = pathname.split('/');

  const values = form.values;
  let queryItems = getQueryString(form).split('&');
  let url;
  if (values.dealerId) {
    url = 'dealer/' + getDisplay(values.dealerId);
    queryItems = queryItems.filter(i => !R.startsWith('dealer.id', i));
  } else {
    if (values.make) {
      url = getAndFormat(values.make);
      queryItems = queryItems.filter(i => !R.startsWith('standardMake', i));
    } else {
      url = 'all';
    }
    if (values.model) {
      url = url + '/' + getAndFormat(values.model);
      queryItems = queryItems.filter(i => !R.startsWith('standardModel', i));
    }

    if (values.category && !values.make && !values.model) {
      url = getAndFormat(values.category);
      queryItems = queryItems.filter(
        i => !R.startsWith('derivative.category', i)
      );
    }
    // Remove undefined or null postcode from query
    if (!values.postcode) {
      queryItems = queryItems.filter(i => !R.startsWith('postcode', i));
    }
  }

  queryItems = queryItems.filter(
    i => !(R.startsWith('lat', i) || R.startsWith('long', i))
  );

  extraParamsFromUrl.map(i => {
    const value = urlParams && urlParams.get(i);
    if (value) {
      queryItems.push(`${i}=${value}`);
    }
  });

  // Regex to match parameters starting with "utm_" or "sfmc_".
  const regex = /^(utm_|sfmc_).*/;

  for (const [key, value] of urlParams) {
    if (regex.test(key)) {
      queryItems.push(`${key}=${value}`);
    }
  }

  const query = queryItems.join('&');

  return path[1]
    ? `/${path[1]}/` + url + `${query ? '?' : ''}` + query
    : '/used-car/' + url + `${query ? '?' : ''}` + query;
};



// WEBPACK FOOTER //
// ./src/Common/buildUrlFromForm/index.js